import * as React from 'react';
import { Pill } from '../../../../../web/components-v2/Pill';

interface IProps {
	name: string;
	onRemove: () => void;
}

export const SelectedItem: React.FC<IProps> = ({ name, onRemove }) => (
	<Pill variant='tag' color='blue' label={name} onRemove={onRemove} />
);
